import './currentSeries.scss'
import { GatsbyImage, StaticImage } from "gatsby-plugin-image";
import React from "react"
import { Button, Media } from "reactstrap";

let imageLoc = "Legacy-WEB.jpg";

const CurrentSeries = ({seriesTitle, messageTitle, image, video, currentMessage, currentSpeaker, data}: any) => {
  return (
    <>
      <a href={video} target='_blank' className="img-fluid">
        <GatsbyImage image={image} alt={messageTitle} className='current-series-image fluid'/>
        <Button variant='Link' size='lg' className="watch-message">
          Watch Recent Message
        </Button>
      </a>
      <div id="current-message-details">
        <h2 className="current-message-title">{currentMessage}</h2>
        <h4 className="current-message-speaker">{currentSpeaker}</h4>
      </div>
    </>
  )
}

export default CurrentSeries;